import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingCencopayCancelledRejectedTransactionError = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="300"
        height="200"
        viewBox="0 0 300 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <rect width="300" height="200" fill="white" />
        <path
          d="M199.287 9.15955C227.325 13.1345 262.503 28.234 268.891 50.4761C275.282 72.7762 252.896 102.164 231.586 125.677C210.283 149.244 190.075 166.939 165.318 178.861C140.564 190.731 111.314 196.913 91.6275 185.717C71.9951 174.6 61.9934 146.134 50.3447 121.065C38.6585 95.9414 25.3014 74.1591 31.6277 58.8893C37.9677 43.6775 63.9911 34.9748 83.5656 29.5011C103.14 24.0274 116.208 21.7214 133.251 17.055C150.235 12.3273 171.192 5.18458 199.287 9.15955Z"
          fill="#F9F9F9"
        />
        <rect
          x="88.4043"
          y="53.7998"
          width="137.344"
          height="94.4242"
          rx="12"
          fill="#B2B2B2"
        />
        <rect
          x="88.4004"
          y="73.5391"
          width="137.344"
          height="15.4512"
          fill="#F9F9F9"
        />
        <rect
          x="109.002"
          y="103.344"
          width="48.0705"
          height="6.00881"
          fill="#F9F9F9"
        />
        <path
          d="M217.5 165C233.24 165 246 152.24 246 136.5C246 120.76 233.24 108 217.5 108C201.76 108 189 120.76 189 136.5C189 152.24 201.76 165 217.5 165Z"
          fill="#E90200"
        />
        <path
          d="M228.712 124L205 149M206.288 124L230 149"
          stroke="#F2F7FF"
          stroke-width="5"
          stroke-miterlimit="10"
        />
      </svg>
    );
  }
);
export default BillingCencopayCancelledRejectedTransactionError;
